<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Procedimento - Inconsistências"
    >
        <template v-if="data">
            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Atendimentos"
                type="fieldset"
            >
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="data.atendimentos.lista"
                    class="p-0"
                >
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Paciente:</strong> {{ item.atendimento.campos.nomeCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.atendimento.campos.cnsCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Data de nascimento:</strong> {{ item.atendimento.campos.dtNascimento }}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-area
                                title="Atendimento"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="CNS"
                                            :value="item.atendimento.campos.cnsCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="CPF"
                                            :value="item.atendimento.campos.cpfCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Prontuário"
                                            :value="item.atendimento.campos.numProntuario"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Data de nascimento"
                                            :value="item.atendimento.campos.dtNascimento"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Sexo"
                                            :value="item.atendimento.campos.sexo"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Local de atendimento"
                                            :value="item.atendimento.campos.localAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Turno"
                                            :value="item.atendimento.campos.turno"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Escuta Inicial/Orientação"
                                            :value="item.atendimento.campos.statusEscutaInicialOrientacao"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="6">
                                        <Item
                                            label="Data/hora inicial do atendimento"
                                            :value="item.atendimento.campos.dataHoraInicialAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <Item
                                            label="Data/hora final do atendimento"
                                            :value="item.atendimento.campos.dataHoraFinalAtendimento"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.atendimento.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Informações gerais"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Circunferência abdominal"
                                            :value="item.informacoesGerais.campos.circunferenciaAbdominal"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Perímetro da panturrilha"
                                            :value="item.informacoesGerais.campos.perimetroPanturrilha"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Pressão arterial"
                                            :value="item.informacoesGerais.campos.pressaoArterial"
                                            append="mmHg"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Frequência respiratória"
                                            :value="item.informacoesGerais.campos.frequenciaRespiratoria"
                                            append="mpm"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Frequência cardíaca"
                                            :value="item.informacoesGerais.campos.frequenciaCardiaca"
                                            append="bpm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Temperatura"
                                            :value="item.informacoesGerais.campos.temperatura"
                                            append="°C"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Saturação de O2"
                                            :value="item.informacoesGerais.campos.saturacaoO2"
                                            append="%"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Peso"
                                            :value="item.informacoesGerais.campos.peso"
                                            append="kg"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Altura"
                                            :value="item.informacoesGerais.campos.altura"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Perímetro cefálico"
                                            :value="item.informacoesGerais.campos.perimetroCefalico"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Glicemia capilar"
                                            :value="item.informacoesGerais.campos.glicemiaCapilar"
                                            append="mg/dL"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Momento da coleta"
                                            :value="item.informacoesGerais.campos.tipoGlicemiaCapilar"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.informacoesGerais.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Procedimentos"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.procedimentos.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'Procedimento' }]"
                                />

                                <Inconsistencia :inconsistencias="item.procedimentos.inconsistencias" />
                            </rkm-area>
                        </div>
                    </template>
                </rkm-list>

                <Inconsistencia :inconsistencias="data.atendimentos.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Procedimentos consolidados (total no período)"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Aferição de PA"
                            :value="data.procedimentosConsolidados.campos.numTotalAfericaoPa"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Curativo"
                            :value="data.procedimentosConsolidados.campos.numTotalCurativoSimples"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Glicemia Capilar"
                            :value="data.procedimentosConsolidados.campos.numTotalGlicemiaCapilar"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Peso"
                            :value="data.procedimentosConsolidados.campos.numTotalMedicaoPeso"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Coleta de material para Exame Laboratorial"
                            :value="data.procedimentosConsolidados.campos.numTotalColetaMaterialParaExameLaboratorial"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Temperatura"
                            :value="data.procedimentosConsolidados.campos.numTotalAfericaoTemperatura"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Altura"
                            :value="data.procedimentosConsolidados.campos.numTotalMedicaoAltura"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.procedimentosConsolidados.inconsistencias" />
            </rkm-area>
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error]
}
</script>